var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useState } from 'react';
import SearchApiService from '../../../Search/services/SearchApiService';
import Highlight from './Highlight';
import Project from './Project';
import LogApiService from '../../../Shared/services/LogApiService';
import Alert, { AlertType } from '../../../Shared/components/Alert';
import LoadingSpinner from '../../../Shared/components/LoadingSpinner';
import { RootContext } from '../../../Context/RootContext';
const Projects = () => {
    const pageSettings = useContext(RootContext).pageContext;
    const pluginSettings = useContext(RootContext).pluginContext;
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    useEffect(() => {
        const getProjects = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const searchResponse = yield SearchApiService.searchWithFacets({
                    sort: {
                        field: 'fields.sorting',
                        direction: 'asc',
                    },
                    from: 0,
                    size: pluginSettings.limit ? pluginSettings.limit : 1000,
                    type: pluginSettings.projectType ? pluginSettings.projectType : null,
                }, 'project', pageSettings.languagePath);
                setProjects(searchResponse.hits.hits);
            }
            catch (error) {
                if (error instanceof Error) {
                    LogApiService.error(error, pageSettings.marathonAppId);
                }
                setError(true);
            }
            setLoading(false);
        });
        getProjects();
    }, []);
    const renderTopProject = (topProject) => {
        return (React.createElement("div", { className: "zds-row zds-margin-bottom-6" },
            React.createElement(Highlight, { key: topProject._id, project: topProject._source.fields, url: topProject._source.url })));
    };
    const renderProjects = (projects) => {
        return (React.createElement("div", { className: "zds-row zds-row-gap-y" }, projects
            .filter((project, index) => index < (pluginSettings.limit || 99))
            .map((project, index) => (React.createElement(Project, { key: project._id, project: project._source.fields, url: project._source.url, index: ++index })))));
    };
    const renderView = () => {
        var _a;
        if (projects.length) {
            let topProjects = projects.filter((project) => project._source.fields.top_object === true);
            const topProject = (_a = topProjects.sort((a, b) => b._source.fields.crdate - a._source.fields.crdate)[0]) !== null && _a !== void 0 ? _a : null;
            const projectsToRender = projects.filter((project) => project._id !== (topProject === null || topProject === void 0 ? void 0 : topProject._id));
            return (React.createElement(React.Fragment, null,
                topProject && renderTopProject(topProject),
                renderProjects(projectsToRender)));
        }
        else if (!loading && !error) {
            return (React.createElement("div", { className: "default-content" },
                React.createElement(Alert, { title: "t(tx_zigrealestate.list.no_objects_found)" })));
        }
        else if (error) {
            return (React.createElement("div", { className: "default-content" },
                React.createElement(Alert, { title: "t(unknownError)", type: AlertType.warning })));
        }
    };
    return (React.createElement(React.Fragment, null,
        loading && React.createElement(LoadingSpinner, null),
        renderView()));
};
export default Projects;
